import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type PaymentsConfirmParams = {
  ids: string[];
};

export const paymentsConfirmAtom = createMutationAtomFactory(
  'finance.paymentsConfirm',
  (params: PaymentsConfirmParams) => ({
    financePaymentsConfirm: {
      __args: {
        input: {
          ids: params.ids,
        },
      },
      results: {
        paymentId: true,
        success: true,
        error: true,
      },
      successCount: true,
      failedCount: true,
    },
  }),
);
